import styled from '@emotion/styled';
import { fontSize, spacing } from 'presentations/views/styles';
import { gray01, gray02 } from 'presentations/views/styles/color';
import Image from 'presentations/views/components/atoms/Image';
import Icon from 'presentations/views/components/atoms/Icon';
import Link from 'presentations/views/components/atoms/Link';
import { LocationType } from 'domains/models/event_type/locationType';
import { imagePath } from 'presentations/assets';
import { formatLocationName } from 'presentations/views/helpers/event_type';

type Props = {
  locationType: LocationType;
  address: string | null;
  access: string | null;
  customLocation: string | null;
};

export default function Component(props: Props) {
  const locationName = formatLocationName(props);
  const googleMapLink = `https://maps.google.co.jp/maps?q=${encodeURIComponent(
    props.address ?? '',
  )}`;

  if (props.locationType === LocationType.InPerson) {
    return (
      <StyledLocationLinkContainer>
        <StyledLocationContainer>
          <StyledLink href={googleMapLink} target="_blank">
            <StyledLocationImage
              src={imagePath(`locations/${LocationType.InPerson}.svg`)}
              alt={locationName}
            />
            <StyledAddress>{props.address}</StyledAddress>
            <StyledIcon
              name="checkbox-multiple-blank-outline"
              size={fontSize(16)}
            />
          </StyledLink>
        </StyledLocationContainer>
        <StyledAccess>{props.access}</StyledAccess>
      </StyledLocationLinkContainer>
    );
  }

  return (
    <StyledLocationContainer>
      <StyledLocationImage
        src={imagePath(`locations/${props.locationType}.svg`)}
        alt={locationName}
      />
      <StyledLocation>{locationName}</StyledLocation>
    </StyledLocationContainer>
  );
}

const StyledLocationLinkContainer = styled.div``;
const StyledLink = styled(Link)`
  display: flex;
  align-items: center;
`;
const StyledAddress = styled.span`
  display: inline-block;
  margin-left: ${spacing(4)};
`;
const StyledAccess = styled.div`
  font-size: ${fontSize(14)};
  line-height: 1.6;
  margin-left: ${spacing(24)};
  margin-top: ${spacing(6)};
  white-space: pre-wrap;
`;
const StyledLocationContainer = styled.div`
  margin-top: ${spacing(8)};
  display: flex;
  align-items: center;
`;
const StyledIcon = styled(Icon)`
  margin-left: ${spacing(8)};
  color: ${gray02};
`;
const StyledLocationImage = styled(Image)`
  height: 20px;
`;
const StyledLocation = styled.div`
  font-size: ${fontSize(14)};
  color: ${gray01};
  line-height: 1.6;
  margin-left: ${spacing(6)};
`;
